// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.specialoffers.RentalManagerUserPropertySpecialOfferV2WebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentalManagerUserPropertySpecialOfferV2WebApiHandler_delete } from '@zg-rentals/ts-rental-manager-api-client';

import type { DeleteListingSpecialOfferRequestDto } from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserPropertySpecialOfferV2WebApiHandler_delete_Args {
  postData: DeleteListingSpecialOfferRequestDto;
}

export type RentalManagerUserPropertySpecialOfferV2WebApiHandler_delete_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertySpecialOfferV2WebApiHandler_delete_Args
>;

/**
 * Delete a listing special offer
 */
export const useRentalManagerUserPropertySpecialOfferV2WebApiHandler_delete = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertySpecialOfferV2WebApiHandler_delete_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertySpecialOfferV2WebApiHandler_delete_Args) =>
      RentalManagerUserPropertySpecialOfferV2WebApiHandler_delete(args.postData, httpClient),
  });
};
